import { selectActiveProjectName, useAppSelector } from '@core/core/store'
import type { ImportFilesResultViewMode } from '@core/core/types'
import { getProjectNameCustomParams } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import type { FC } from 'react'
import { useLocation } from 'react-router'

import { NewImportFromDBSelector } from './NewImportFromDBSelector'
import { NewImportFromLocalFilesSelector } from './NewImportFromLocalFilesSelector'
import css from './NewImportFromLocalFilesSelector.css'
import type { NewImportSourceSelectorProps as Props } from './types'

export const NewImportSourceSelector: FC<Props> = ({
  globalSearch,
  onDbSelect,
  getFilesFromExplorer,
}) => {
  const sendSpaEvent = useSpa()
  const activeProjectName = useAppSelector(selectActiveProjectName)
  const params = getProjectNameCustomParams(activeProjectName)
  const { pathname: path } = useLocation()

  const onLocalFileSelect = (mode: ImportFilesResultViewMode) => {
    switch (mode) {
      case 'survey3D':
        {
          getFilesFromExplorer()
          sendSpaEvent('import from PC_3D', params)
        }
        break
      case 'markers':
        {
          getFilesFromExplorer('Markers')
          sendSpaEvent('import from PC_markers', params)
        }
        break

      default:
        console.error(`Получено значение ${mode} для которого отсутствует обработчик`)
    }
  }

  const getLinkOnImport = (mode: ImportFilesResultViewMode) => {
    switch (mode) {
      case 'bulk':
        return `${path}/bulk`
      default:
        return undefined
    }
  }

  return (
    <div className={css.sourcesWrapper}>
      <div className={css.sourcesContainer}>
        <NewImportFromDBSelector globalSearch={globalSearch} onSelect={onDbSelect} />
        <NewImportFromLocalFilesSelector
          getLinkOnImport={getLinkOnImport}
          onSelect={onLocalFileSelect}
        />
      </div>
    </div>
  )
}
